export enum WafflesFilterType {
  string,
  number,
  boolean,
  dateTime,
}
